import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { IUserAssignment } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateGetUserAssignments } from "./useGetUserAssignments";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  payload: IUserAssignment;
};

const createUserAssignment = async ({
  countryCode,
  clientInternalNumberGOS,
  payload,
}: Params): Promise<IUserAssignment> => {
  const response = await api.post(
    `/hbhuserassignment/${countryCode}/${clientInternalNumberGOS}`,
    {
      ...payload,
    }
  );

  return response.data as IUserAssignment;
};

export function useCreateUserAssignment(refetch = true) {
  const invalidateUserAssignments = useInvalidateGetUserAssignments();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(createUserAssignment, {
    mutationKey: MUTATION_KEYS.createUserAssignment,
    onSuccess: () => {
      if (refetch) {
        invalidateUserAssignments();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
